import {
  Radio as MatRadio,
  RadioGroup,
  FormControlLabel,
  RadioGroupProps,
} from "@material-ui/core";
import { ReactNode, forwardRef } from "react";
import * as S from "./styles";
import { Tooltip } from "@material-ui/core";

interface Option {
  label: string;
  value: string;
  tooltipText?: string;
}

export interface RadioProps extends RadioGroupProps {
  options: Option[];
  label?: ReactNode;
  customLabel?: string;
  error?: boolean;
  helperText?: string;
}

const TooltipWrapper = forwardRef<HTMLDivElement, { children: ReactNode }>(
  function TooltipWrapper({ children }, ref) {
    return <div ref={ref}>{children}</div>;
  }
);

export const Radio = forwardRef<HTMLDivElement, RadioProps>(
  function Radio(
    {
      options = [],
      label,
      customLabel,
      error,
      helperText,
      value = "",
      ...rest
    },
    ref
  ) {
    return (
      <div>
        <label>
          {customLabel}
          <RadioGroup {...rest} value={value || ""} ref={ref}>
            {options.map((option, index) => {
              const radioElement = (
                <FormControlLabel
                  label={option.label}
                  value={option.value}
                  control={<MatRadio color="primary" />}
                />
              );

              return option.tooltipText ? (
                <Tooltip
                  key={option.value || index}
                  title={option.tooltipText}
                >
                  <TooltipWrapper>{radioElement}</TooltipWrapper>
                </Tooltip>
              ) : (
                <span key={option.value || index}>{radioElement}</span>
              );
            })}
          </RadioGroup>
        </label>

        {error && <S.ErrorMessage>{helperText}</S.ErrorMessage>}
      </div>
    );
  }
);
